import { InitializeUndoRedoStack, Redo, SaveEditorContentState, Undo } from '~/constants/mutations';
import { GetEditorContent, GetRedoStack, GetUndoStack } from '~/constants/getters';

const MAX_LIMIT = 15;

const defaultState = () => {
  return {
    editorContent: '',
    undoStack: [],
    redoStack: [],
  };
};

export const mutations = {
  [SaveEditorContentState]: (state, newContent) => {
    if (state.undoStack.length >= MAX_LIMIT) {
      state.undoStack.shift(); //remove the first element
    }
    if (state.editorContent) {
      state.undoStack.push(state.editorContent);
    }
    state.editorContent = newContent;
    state.redoStack = []; // Clear redo stack on new edit
  },
  [Undo]: (state) => {
    if (state.undoStack.length > 0) {
      if (state.redoStack.length >= MAX_LIMIT) {
        state.redoStack.shift(); //remove the first element
      }
      state.redoStack.push(state.editorContent);
      state.editorContent = state.undoStack.pop();
    }
  },
  [InitializeUndoRedoStack]: (state, { undo, redo }) => {
    state.undoStack = undo;
    state.redoStack = redo;
  },
  [Redo]: (state) => {
    if (state.redoStack.length > 0) {
      if (state.undoStack.length >= MAX_LIMIT) {
        state.undoStack.shift(); //remove the first element
      }
      state.undoStack.push(state.editorContent);
      state.editorContent = state.redoStack.pop();
    }
  },
};

export const actions = {
  [SaveEditorContentState]: ({ commit }, data) => {
    commit(SaveEditorContentState, data);
  },
  [Undo]: ({ commit }) => {
    commit(Undo);
  },
  [Redo]: ({ commit }) => {
    commit(Redo);
  },
  [InitializeUndoRedoStack]: ({ commit }, data) => {
    commit(InitializeUndoRedoStack, data);
  },
};

export const getters = {
  [GetEditorContent]: (state) => state.editorContent,
  [GetUndoStack]: (state) => state.undoStack,
  [GetRedoStack]: (state) => state.redoStack,
};

export const state = defaultState();

export default {
  namespaced: true, // Important for namespacing module
  state,
  mutations,
  actions,
  getters,
};
